import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-video-iframe="container"]',
        playBtn: '[js-video-iframe="play-button"]',
        cover: '[js-video-iframe="cover"]',
    }

    function init() {
        $(nodeSelectors.container).each(function () {
            let $container = $(this)
            let $iframe = $container.find('iframe')
            let $playBtn = $container.find(nodeSelectors.playBtn)
            let $cover = $container.find(nodeSelectors.cover)

            $($playBtn).on('click', function () {
                let iframeSrc = $(this).data('video-iframe--src')
                $playBtn.hide()
                $cover.hide()

                if( $iframe.length ) {
                    $iframe.attr('src', iframeSrc)
                } else {
                    $container.append('<iframe src="' + iframeSrc + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>')
                    $iframe = $container.find('iframe')
                    $iframe.attr('src', iframeSrc)
                    // $iframe.on('load', function () {})
                }
            })
        })
    }

    return Object.freeze({
        init,
    })
}